import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
export function WhoIsFor() {
  const isFor = ['Profesionales que necesitan mantener un enfoque agudo bajo presión sin depender de estimulantes.', 'Padres y madres que quieren llegar al final del día con energía para su familia, no solo para su trabajo.', 'Personas de más de 40 años que sienten que su cuerpo ha envejecido "de golpe" en los últimos años.', 'Cualquier persona que busque una solución basada en biología real y no en promesas mágicas de marketing.'];
  const notFor = ['Personas que buscan una "pastilla milagrosa" para adelgazar sin cambiar sus señales biológicas.', 'Lectoras que no están dispuestas a dedicar 15 minutos en la mañana a su propia biología.', 'Quienes prefieren seguir culpando a "la edad" en lugar de tomar control de sus hábitos.'];
  return <section className="py-24 relative" data-id="element-161">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-162">
        <div className="grid md:grid-cols-2 gap-8 lg:gap-12" data-id="element-163">
          {/* Left Column - Is For */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-white/[0.02] rounded-3xl p-8 border border-green-500/20" data-id="element-164">
            <h3 className="text-2xl font-bold text-white mb-8 flex items-center gap-3" data-id="element-165">
              <div className="bg-green-500/20 p-2 rounded-full" data-id="element-166">
                <Check className="w-6 h-6 text-green-400" data-id="element-167" />
              </div>
              Esto es para ti si...
            </h3>
            <ul className="space-y-6" data-id="element-168">
              {isFor.map((text, i) => <li key={i} className="flex items-start gap-4" data-id="element-169">
                  <Check className="w-5 h-5 text-green-400 shrink-0 mt-1" data-id="element-170" />
                  <span className="text-gray-300 leading-relaxed" data-id="element-171">{text}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* Right Column - Not For */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-white/[0.02] rounded-3xl p-8 border border-red-500/20" data-id="element-172">
            <h3 className="text-2xl font-bold text-white mb-8 flex items-center gap-3" data-id="element-173">
              <div className="bg-red-500/20 p-2 rounded-full" data-id="element-174">
                <X className="w-6 h-6 text-[#ff6b6b]" data-id="element-175" />
              </div>
              Esto NO es para ti si...
            </h3>
            <ul className="space-y-6" data-id="element-176">
              {notFor.map((text, i) => <li key={i} className="flex items-start gap-4" data-id="element-177">
                  <X className="w-5 h-5 text-[#ff6b6b] shrink-0 mt-1" data-id="element-178" />
                  <span className="text-gray-300 leading-relaxed" data-id="element-179">{text}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}